import { useViewRecordsPopoverStore } from '@aibees/elephant/store/view-records-popover';
import { memo, useCallback } from 'react';
import { ViewRecordButton } from './view-record-button';

export const ViewRecordsHeaderAction = memo(function ViewRecordsHeaderAction() {
  const visible = useViewRecordsPopoverStore.useVisible();
  const open = useViewRecordsPopoverStore.useOpen();
  const compact = useViewRecordsPopoverStore.useCompact();
  const onOpen = useViewRecordsPopoverStore.useOnOpen();

  const handleOpen = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      onOpen(e.currentTarget);
    },
    [onOpen]
  );

  if (!visible) return null;

  return (
    <ViewRecordButton onOpen={handleOpen} isOpen={!!open} compact={compact} />
  );
});
